import React, { useCallback, useState, useEffect } from "react";
import { toast } from "react-toastify";
import ImageUploadComponent from "../../pages/subscription/asset";
import { updateScorecard } from "../../apis/users";

const Add = ({ fetch, data, setTimer }) => {
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({ score: data?.score || 0 });

  const openHandler = useCallback(() => {
    setOpen(!open);
  }, [open]);

  const changeHandler = useCallback(
    (e) => {
      setFormData({ score: e.target.value });
    },
    [formData]
  );

  const submitHandler = useCallback(async () => {
    try {
      if (formData.score < 0) {
        toast.error("Score must be greater than or equal to 0");
        return;
      }
      await updateScorecard(data.name, formData);
      fetch();
      setOpen(false);
      toast.success("Scorecard updated successfully");
    } catch (error) {
      console.log(error);
      toast.error("Something went wrong");
    }
  }, [formData]);
  return (
    <div className="modal-container">
      <div className="add-modal">
        <button className="info" onClick={openHandler}>
          Edit
        </button>
      </div>
      <div className={open ? "modal active" : "modal"}>
        <div className="wrapper">
          <div className="header">
            <h2>Edit {data.name} Scorecard</h2>
            <button type="button" className="danger" onClick={openHandler}>
              Close
            </button>
          </div>
          <div className="content">
            <div className="form-section">
              <h4>Score</h4>
              <div className="input-wrapper">
                <label>
                  Score
                  <span className="required">*</span>
                </label>
                <input
                  name="score"
                  type="number"
                  value={formData.score}
                  onChange={changeHandler}
                />
              </div>
            </div>
          </div>
          <div className="footer">
            <button onClick={submitHandler} type="button" className="primary">
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Add;
